"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const _1 = require("./../");
const string_1 = require("./utils/string");
exports.DatagridTable = (props) => {
    const { children, tableMinWidth } = props;
    return (React.createElement("div", { className: "bkn-data-grid-table" },
        React.createElement("div", { className: "grid-table", style: { tableMinWidth } },
            React.createElement("div", { className: "grid-thead" },
                React.createElement("div", { className: "grid-tr" }, renderHeaders(props))),
            children)));
};
exports.DatagridTable.displayName = 'DatagridTable';
const renderHeaders = (props) => {
    const { properties, sort } = props;
    return properties.map((p, index) => (React.createElement("div", { key: index, className: classNames('grid-th', {
            active: string_1.getSortProperty(sort) === p.sortKey,
            asc: p.sortKey && sort.indexOf('-') !== 0,
            desc: p.sortKey && sort.indexOf('-') === 0,
            'no-sort': !p.sortKey,
        }), style: p.thStyle, onClick: handleSortInfo(props, p.sortKey) },
        React.createElement("span", null, p.name),
        p.sortKey && React.createElement(_1.Icon, { className: "sort-icon", name: "arrow_upward" }))));
};
const handleSortInfo = (props, columnPropertyKey) => () => {
    if (!columnPropertyKey) {
        return;
    }
    const hasToSortSameColumn = string_1.getSortProperty(props.sort) === columnPropertyKey;
    if (hasToSortSameColumn) {
        props.onSort(invertSortingDirection(props.sort));
        return;
    }
    props.onSort(columnPropertyKey);
};
const invertSortingDirection = (property) => {
    return string_1.isSortDescending(property)
        ? property.substr(1)
        : `-${property}`;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridTable.tsx
// module id = 251
// module chunks = 0